export default __webpack_public_path__ + "static/media/Early fall Dark.64d7cbeb.svg";